<template>
  <ul  v-if="false" class="nav nav-mobile-menu">
    <li>
      <a href="javascript:void(0)" class="btn-rotate"  v-if="false">
        <img src="static/img/icon_settings.svg" alt="Icon" class="nav-icon">
        <p class="hidden-md hidden-lg">
          {{ $t('labels.settings') }}
        </p>
      </a>
    </li>
    <li v-if="false" icon="ti-bell">
      <router-link to="/notifications/list" class="btn-rotate" @click.native="closeSidebar">
        <img src="static/img/icon_bell.svg" alt="Icon" class="nav-icon">
        <p class="hidden-md hidden-lg">
          {{ $t('labels.notifications') }}
          <span class="notification" v-if="unreadNotificationsCount">{{unreadNotificationsCount}}</span>
        </p>
      </router-link>
    </li>
    <!-- <drop-down tag="li" title="4 Уведомления" icon="ti-bell" v-if="false">
      <a slot="title" href="javascript:void(0)" class="dropdown-toggle btn-rotate" data-toggle="dropdown">
        <img src="static/img/icon_clipboard.svg" alt="Icon" class="nav-icon">
        <p class="hidden-md hidden-lg">
          Задачи
          <span class="notification">8</span>
          <b class="caret"></b>
        </p>
      </a>
      <li><a href="javascript:void(0)">Задача 1</a></li>
      <li><a href="javascript:void(0)">Задача 2</a></li>
      <li><a href="javascript:void(0)">Задача 3</a></li>
      <li><a href="javascript:void(0)">Задача 4</a></li>
    </drop-down> -->
  </ul>
</template>
<script>
  import dropDown from 'src/components/Dropdown/Dropdown.vue'
  export default {
    components: {
      dropDown
    },
    methods: {
      closeSidebar (event) {
        this.$store.commit('sidebarOpened', false)
      }
    },
    computed: {
      unreadNotificationsCount () {
        return 0
      }
    }
  }
</script>
<style>
</style>